var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2829 0H30.1267L19.5443 12.0956L31.994 28.5544H22.2457L14.6109 18.572L5.87476 28.5544H1.02765L12.3467 15.6171L0.403931 0H10.3992L17.3006 9.12411L25.2829 0ZM23.5827 25.6549H26.267L8.94085 2.74729H6.06072L23.5827 25.6549Z",
    fill: "#11998E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5901,
    height: 28.5544,
    fill: "white",
    transform: "translate(0.403931)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.39d95296c6d6a6be344a16ffd1a68f44.svg";
export { ForwardRef as ReactComponent };